import React from 'react'

const ProformaInvoiceViewPage = () => {
  return (
    <div>ProformaInvoiceViewPage</div>
  )
}

export default ProformaInvoiceViewPage